import SummitAttendeeCFNs from './SummitAttendeeCFNs'

export default SummitAttendeeCFNs
